import { Box, Stack, styled } from "@mui/material";
import Placeholder from "@Resources/game/backgrounds/3.jpg";

export const PlaylistBannerCardRoot = styled(Box)<{ imageUrl?: string }>(({ theme, imageUrl }) => {
  const encodedImageUrl = imageUrl ? encodeURI(imageUrl) : Placeholder;
  return {
    position: "relative",
    height: "100%",
    backgroundImage: `url(${encodedImageUrl})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    filter: "saturate(70%)",
  };
});

export const PlaylistBannerCardContent = styled(Stack)(({ theme }) => ({
  position: "absolute",
  left: theme.spacing(6),
  zIndex: 1,
  height: "100%",
  justifyContent: "center",
  maxWidth: theme.spacing(90),
}));

export const PlaylistBannerCardBottomGradient = styled(Box)(({ theme }) => ({
  position: "absolute",
  width: "100%",
  height: theme.spacing(25),
  bottom: -1,
  background: "linear-gradient(0deg, #121316 0%, rgba(18, 19, 22, 0.00) 100%)",
}));

export const HeroOverlay = styled(Box)(({ theme }) => ({
  position: "absolute",
  inset: 0,
  background: "rgba(18, 19, 22, 0.9)",
}));

export const PlaylistRowStack = styled(Stack)(({ theme }) => ({
  padding: theme.spacing(0, 6),
  boxSizing: "border-box",
  "& > *": {
    minWidth: 0,
    flex: 1,
  },
}));
